import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { MessageFactory } from "../../../lib/messages";
import { Protocol, Globals } from "../../../lib/constants";
import {
  OPBox,
  OPHeader,
  Title,
  Button,
  SeedInput,
  Description,
} from "./provFairStyled";
// import { ScalingContainer } from "../../../AppStyled";
import { Frame, ScalingContainer } from "../../../AppStyled";

import { ReactComponent as CloseSVG } from "../../../svg/closePF.svg";

import { Detailed } from "./provFairDetailed";
import useSound from "use-sound";
import closeSound from "../../../audio/goBack.mp3";
// import SetSound from "../../../audio/provablyFairSet.mp3";
import confirm from "../../../audio/confirm.mp3";

export function ProvFair({
  unBlur,
  notifyText,
  handleNotification,
  handleAbove,
  isClickable,
  isAutoOn = false,
  aboveAnim = true,
  h,
  scrollable,
  sound,
  music,
  volume,
}) {
  // const handleAboveAnim = () => {};
  // const handleSettingsOut = () => {};
  // const [setSFX] = useSound(SetSound, { volume });
  const [confirmSFX] = useSound(confirm, { volume });
  const [closeSFX] = useSound(closeSound, { volume });
  const [seedError, setSeedError] = useState(false);

  const st = useSelector(
    (s) => s,
    () => {}
  );
  const {
    client_seed,
    server_seed_SHA256,
    nonce,
    old_client_seed,
    old_server_seed,
    old_server_seed_SHA256,
    old_nonce,
    next_server_seed_SHA256,
  } = st.provablyFairSeeds;

  const [inputSeed, setinputSeed] = useState("");
  const [setA, setSetA] = useState(false);

  const ProvFairTitle = {
    Title: "Explanation",
    Description: ` There are several implementations of the provably fair method, we
    will describe the most common one. With this method each roll-result
    is calculated by the following variables:`,
  };
  const ProvFairText = [
    {
      Title: "Server seed",
      Description: `provided by the gambling site`,
    },
    {
      Title: "Nonce",
      Description: ` A number that increases with each random number is needed.`,
    },
    {
      Title: "Client seed",
      Description: `provided by your browser and adjusted by you`,
    },
    {
      Title: "Hash",
      Description: `Encrypted data`,
    },
  ];

  const changeHandler = (e) => {
    let val = e.target.value;
    const reg = /^[A-Za-z0-9]+$/;

    if (reg.test(val) || val === "") {
      setinputSeed(val);
    }
    if (val.length >= 16 && val.length <= 128) {
      setSeedError(false);
      handleNotification(false);
    }
  };
  const submit = () => {
    if (inputSeed.length >= 16 && inputSeed.length <= 128) {
      Globals.WS.sendMessage(
        MessageFactory.createMessage(Protocol.SET_SEED, inputSeed)
      );
      handleNotification(false);
      setSeedError(false);
      setinputSeed("");
    } else {
      setSeedError(true);

      handleNotification(
        "Minimum length of seed must be 16 symbols and maximum - 128."
      );
    }
  };

  useEffect(() => {
    Globals.WS.sendMessage(MessageFactory.createMessage(Protocol.GET_SEEDS));
  }, []);
  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };

  const ClientseedRef = useRef(null);
  const Serverseed = useRef(null);
  const Nonce = useRef(null);
  const Oldclientseed = useRef(null);
  const Oldserverseed = useRef(null);
  const Oldserverseedhash = useRef(null);
  const Oldnonce = useRef(null);
  const nextServerseed = useRef(null);

  const copyToClipboard = (e) => {
    e.current.select();
    document.execCommand("copy");
    handleNotification("Copied to clipboard");
  };
  const VfCheck = () => {
    window.open('https://codepen.io/orbitalgaming/pen/LYaZLwg', '_blank')
  }

  return (
    <Frame className="Frame" unBlur={unBlur} scrollable={scrollable}>
      <ScalingContainer className="ScalingContainer" h={h}>
        <OPBox>
          <OPHeader aboveAnim={aboveAnim}>
            <p>Prov. Fair</p>
            <span
              onClick={() => {
                if (sound) closeSFX();
                handleAbove(false);
                // handleAboveAnim(false);
                // setTimeout(() => {
                //   handleSettingsOut(false);
                // }, 550);
              }}
            >
              <CloseSVG />
            </span>
          </OPHeader>
          <Title>
            <h4>Clients seed</h4>
            {/* <p>{client_seed}</p> */}
            <textarea
              ref={ClientseedRef}
              onClick={() => copyToClipboard(ClientseedRef)}
              value={client_seed}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title>
            <h4>Server seed hash</h4>
            {/* <p>{server_seed_SHA256}</p> */}
            <textarea
              ref={Serverseed}
              onClick={() => copyToClipboard(Serverseed)}
              value={server_seed_SHA256}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title>
            <h4>Nonce</h4>
            {/* <p>{nonce}</p> */}
            <textarea
              ref={Nonce}
              onClick={() => copyToClipboard(Nonce)}
              value={nonce}
              spellCheck="false"
              readOnly="readOnly"
              className="nonce"
            />
          </Title>
          <Title>
            <h4>Next server seed hash</h4>
            <textarea
              ref={nextServerseed}
              onClick={() => copyToClipboard(nextServerseed)}
              value={next_server_seed_SHA256}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>

          <form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
            }}
            onClick={
              !isClickable || isAutoOn
                ? () =>
                    handleNotification("You can't change seed while game is on")
                : undefined
            }
          >
            <SeedInput
              name="input"
              placeholder="New seed"
              spellCheck="false"
              onChange={changeHandler}
              value={inputSeed}
              notify={seedError}
              clickable={!isClickable}
              autoOn={isAutoOn}
            />
            <Button
              setA={setA}
              onClick={() => {
                if (sound) confirmSFX();
                setAnimation(setA, setSetA);
                setTimeout(() => {
                  submit();
                }, 200);
              }}
              clickable={!isClickable}
              autoOn={isAutoOn}
            >
              SET
            </Button>
          </form>
          <Title>
            <h4>Previous seed pair</h4>
          </Title>
          <Title copyCursor={old_client_seed === ""}>
            <h4>Clients seed</h4>
            <textarea
              ref={Oldclientseed}
              onClick={() =>
                old_client_seed !== "" && copyToClipboard(Oldclientseed)
              }
              value={old_client_seed !== "" ? old_client_seed : "clients seed"}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title copyCursor={old_server_seed === ""}>
            <h4>Server seed</h4>
            <textarea
              ref={Oldserverseed}
              onClick={() =>
                old_server_seed !== "" && copyToClipboard(Oldserverseed)
              }
              value={old_server_seed !== "" ? old_server_seed : "server seed"}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title copyCursor={old_server_seed_SHA256 === ""}>
            <h4>Server seed hash</h4>
            <textarea
              ref={Oldserverseedhash}
              onClick={() =>
                old_server_seed_SHA256 !== "" &&
                copyToClipboard(Oldserverseedhash)
              }
              value={
                old_server_seed_SHA256 !== ""
                  ? old_server_seed_SHA256
                  : "server seed hash"
              }
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Title copyCursor={old_nonce === "" || old_nonce === 0}>
            <h4>Nonce</h4>
            <textarea
              ref={Oldnonce}
              onClick={() => old_nonce !== "" && copyToClipboard(Oldnonce)}
              value={old_nonce}
              spellCheck="false"
              readOnly="readOnly"
            />
          </Title>
          <Button className={old_client_seed === "" || old_client_seed === undefined ? 'disabled':''}  onClick={() => VfCheck()}>Verify</Button>
          <Description>
            <h3>{ProvFairTitle.Title}</h3>
            <p>{ProvFairTitle.Description}</p>
          </Description>
          {ProvFairText.map((item, id) => (
            <Description key={id}>
              <h4>{item.Title}</h4>
              <p>{item.Description}</p>
            </Description>
          ))}
          <Detailed />
        </OPBox>
      </ScalingContainer>
    </Frame>
  );
}

// import React, { Component } from "react";
// import { connect } from "react-redux";
// import { turnMode } from "../../../redux/actions/postActions";
// import { ReactComponent as CloseSVG2 } from "../../../svg/close2.svg";
// import { ReactComponent as PlusSVG } from "../../../svg/ProvPlus.svg";
// import { ReactComponent as EqSVG } from "../../../svg/ProvEq.svg";

// import {
//   ProvFairDiv,
//   Header,
//   Body,
//   Seed,
//   NewSeed,
//   Set,
//   Buttons,
//   Title,
//   SubTitle,
//   Description,
//   DescriptionBox,
//   DetailedContainer,
//   DetailedHeader,
//   DetailedDescription,
//   DetailedBoxWrapper,
//   DetailedColumn,
//   DetailedBox,
//   DetailedTitle,
//   DetailedRectBox,
//   DetailedOvalBox,
//   DetailedRhombBox,
//   DetailedSVGBox,
//   DetailedCircleR,
//   DetailedCircleL,
//   DetailedCircleT,
//   DetailedCircleB,
//   DetailedCircleBC,
//   DetailedCircleTC,
//   LineDownD,
//   LineUpD,
//   LineV,
//   LineH,
//   LineD
// } from "./provFairStyled";

// class provFair extends Component {
//   render() {
//     const {
//       clientSeed,
//       serverSeedSHA256,
//       nonce
//     } = this.props.provablyFairSeeds;
//     return (
//       <ProvFairDiv>
//         <Header>
//           <p>prov. fair</p>
//           <CloseSVG2 onClick={() => this.props.handleAbove(false)} />
//         </Header>
//         <Body>
//           <div>
//             <Seed>
//               <h1>Client seed</h1>
//               <p>{clientSeed}</p>
//             </Seed>
//             <Seed>
//               <h1>Server seed hash</h1>
//               <p>{serverSeedSHA256}</p>
//             </Seed>
//             <Seed>
//               <h1>Nonce</h1>
//               <p>{nonce}</p>
//             </Seed>
//           </div>
//           <Buttons>
//             <NewSeed placeholder="New Seed" />
//             <Set>set</Set>
//           </Buttons>
//         </Body>
//         <DescriptionBox>
//           <Title>explanation</Title>
//           <Description>
//             There are several implementations of the provably fair method, we
//             will describe the most common one. With this method each roll-result
//             is calculated by the following variables:
//           </Description>
//         </DescriptionBox>
//         <DescriptionBox>
//           <SubTitle>Serverseed</SubTitle>
//           <Description>provided by the gambling site</Description>
//           <SubTitle>Nonce</SubTitle>
//           <Description>
//             A number that increases with each random numbers needed.
//           </Description>
//           <SubTitle>Clientseed</SubTitle>
//           <Description>
//             provided by your browser and adjusted by you
//           </Description>
//           <SubTitle>Hash</SubTitle>
//           <Description>Encrypted data</Description>
//         </DescriptionBox>
//         <DetailedContainer>
//           <DetailedHeader>Before Game</DetailedHeader>
//           <DetailedDescription>
//             You will get an encrypted Hash of the Serverseed before you start
//             gambling. Sinceyou get it in advance, the site cannot change it
//             later. However, it is encrypted, so you cannot calculate your own
//             state results in advance (only afterwards if you get the Unhashed
//             Serverseed.)
//           </DetailedDescription>
//           <DetailedBoxWrapper>
//             <DetailedColumn className="BorderR">
//               <DetailedTitle>User</DetailedTitle>
//               <DetailedBox>
//                 <DetailedRectBox>
//                   Seed
//                   <LineD></LineD>
//                   <DetailedCircleBC></DetailedCircleBC>
//                 </DetailedRectBox>
//                 <DetailedOvalBox>Seed</DetailedOvalBox>
//                 <DetailedOvalBox>
//                   Hash Seed
//                   <LineUpD></LineUpD>
//                   <DetailedCircleR></DetailedCircleR>
//                 </DetailedOvalBox>
//               </DetailedBox>
//             </DetailedColumn>
//             <DetailedColumn>
//               <DetailedTitle>Server</DetailedTitle>
//               <DetailedBox>
//                 <DetailedOvalBox>
//                   Seed
//                   <LineV></LineV>
//                   <DetailedCircleB></DetailedCircleB>
//                 </DetailedOvalBox>
//                 <DetailedOvalBox>
//                   Hash Seed
//                   <DetailedCircleT></DetailedCircleT>
//                   <DetailedCircleL></DetailedCircleL>
//                 </DetailedOvalBox>
//                 <DetailedRectBox>
//                   Seed
//                   <DetailedCircleTC></DetailedCircleTC>
//                 </DetailedRectBox>
//               </DetailedBox>
//             </DetailedColumn>
//           </DetailedBoxWrapper>
//           <DetailedHeader>Game</DetailedHeader>
//           <DetailedDescription>
//             Your browser will generate a random Clientseed. However, you could
//             and should adjust this Clientseed before you start. This way you can
//             make sure the site does not know your Clientseed before start game
//             and server already send you the encrypted Hash of the Serverseed, so
//             server cannot change it after getting Clientseed.
//           </DetailedDescription>
//           <DetailedBoxWrapper>
//             <DetailedColumn className="BorderR">
//               <DetailedTitle>User</DetailedTitle>
//               <DetailedBox>
//                 <DetailedRectBox>Seed</DetailedRectBox>
//                 <DetailedRhombBox>
//                   Outcome
//                   <LineH></LineH>
//                   <DetailedCircleR className="RhombR"></DetailedCircleR>
//                 </DetailedRhombBox>
//               </DetailedBox>
//             </DetailedColumn>
//             <DetailedColumn>
//               <DetailedTitle>Server</DetailedTitle>
//               <DetailedBox>
//                 <DetailedRectBox>Seed</DetailedRectBox>
//                 <DetailedSVGBox>
//                   <PlusSVG></PlusSVG>
//                 </DetailedSVGBox>
//                 <DetailedOvalBox>Hash Seed</DetailedOvalBox>
//                 <DetailedSVGBox>
//                   <PlusSVG></PlusSVG>
//                 </DetailedSVGBox>
//                 <DetailedOvalBox>
//                   None 3 <span></span>
//                 </DetailedOvalBox>
//                 <DetailedSVGBox>
//                   <EqSVG></EqSVG>
//                 </DetailedSVGBox>
//                 <DetailedRhombBox>
//                   Outcome
//                   <DetailedCircleL className="RhombL"></DetailedCircleL>
//                 </DetailedRhombBox>
//               </DetailedBox>
//             </DetailedColumn>
//           </DetailedBoxWrapper>
//           <DetailedHeader>After Game</DetailedHeader>
//           <DetailedDescription>
//             Now if you make a bet the Nonce starts with 0 or 1. After each bet
//             you make, the Nonce number will go up by 1
//           </DetailedDescription>
//           <DetailedBoxWrapper className="BorderNone">
//             <DetailedColumn className="BorderR">
//               <DetailedTitle>User</DetailedTitle>
//               <DetailedBox>
//                 <DetailedOvalBox>
//                   Hash Seed
//                   <LineDownD></LineDownD>
//                   <DetailedCircleR></DetailedCircleR>
//                 </DetailedOvalBox>
//                 <DetailedOvalBox>
//                   Hash Seed
//                   <LineUpD></LineUpD>
//                   <DetailedCircleR></DetailedCircleR>
//                 </DetailedOvalBox>
//               </DetailedBox>
//             </DetailedColumn>
//             <DetailedColumn>
//               <DetailedTitle>Server</DetailedTitle>
//               <DetailedBox className="Centered">
//                 <DetailedOvalBox>
//                   Hash Seed
//                   <DetailedCircleL></DetailedCircleL>
//                 </DetailedOvalBox>
//               </DetailedBox>
//             </DetailedColumn>
//           </DetailedBoxWrapper>
//         </DetailedContainer>
//       </ProvFairDiv>
//     );
//   }
// }
// const mapStateToProps = state => {
//   return state;
// };

// const mapDispatchToProps = dispatch => {
//   return {
//     turnMode: i => dispatch(turnMode(i))
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(provFair);

// // TODO BACK
